/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/5
 */
import {combineReducers} from 'redux';
import home from './home';
import user from './user';
import app from './app';
import step from './step';
import search from './search';
import {routerReducer} from 'react-router-redux';

export default combineReducers({
  app,
  user,
  home,
  step,
  search,
  router: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js